import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import { StaffPost } from "../../types/types";

export const useStaffPosts = () => {
  const setPosts = useAppStore((state) => state.setPosts);

  const [{ response: staffPostsData }, doFetchStaffPosts] = useFetch("/directories/posts");

  useEffect(() => {
    let staffPosts = staffPostsData?.data as unknown as StaffPost[];
    if (staffPosts) setPosts(staffPosts);
  }, [staffPostsData]);

  return doFetchStaffPosts;
};
